export const useBanner = (data1, data2, type) => {
  if (type === "single collection") return data1
  if (type === "single category") return data2
  if (type === "collections") return data1
  if (type === "categories") return data2
  return data1
}
